export default "__VITE_ASSET__QmJofa4w__"